var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_52661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 8.00033C9.47268 8.00033 10.666 6.80699 10.666 5.33366C10.666 3.86033 9.47268 2.66699 7.99935 2.66699C6.52602 2.66699 5.33268 3.86033 5.33268 5.33366C5.33268 6.80699 6.52602 8.00033 7.99935 8.00033ZM7.99935 9.33366C6.21935 9.33366 2.66602 10.227 2.66602 12.0003V12.667C2.66602 13.0337 2.96602 13.3337 3.33268 13.3337H12.666C13.0327 13.3337 13.3327 13.0337 13.3327 12.667V12.0003C13.3327 10.227 9.77935 9.33366 7.99935 9.33366Z",
    fill: "#265183"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_52661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my-account.c4d82d9f05df3e7fe0af86ee957184df.svg";
export { ForwardRef as ReactComponent };